module.exports = __webpack_public_path__ + "img/s5.bd9beeea.png";